(function() {

    const GAMIFICATION_URL_PARAMS_CASE = 'gamification_url_params_case';
    const GAMIFICATION_SECTIONS_CASE = {
        0: 'gamification-section',
        1: 'gamification-section-1',
        2: 'gamification-section-2',
    };

    async function initCartGamification() {
        const cartGamification = document.querySelector('.CartGamification');
        // const giftInCart = document.querySelector('.CartItemWrapper.is-gift');

        const cartJson = await fetch(`/cart.js`).then(e=>e.json());
        const giftInCart = cartJson.items.find(item => item.properties._gift === 'true');

        console.log('TNTE initCartGamification', giftInCart, cartGamification.getAttribute('data-status'));

        if (( cartGamification.getAttribute('data-status') === 'gift_granted' ||
            cartGamification.getAttribute('data-status') === 'shipping_gift_granted') && !giftInCart) {
                // console.log('TNTE initCartGamification 1');
                if(cartGamification.getAttribute('data-gift') != '') {
                    console.log('TNTE initCartGamification 2');
                    let items = [
                        {
                            id: cartGamification.getAttribute('data-gift'),
                            quantity: 1,
                            properties: {
                                "_gift": "true"
                            }
                        }
                    ];
                    if(cartGamification.getAttribute('data-pfand')){
                        let pfandKey =cartGamification.getAttribute('data-pfand') + "-" + Math.random().toString(16).slice(2);
                        items.push({
                            id: window.theme.pfand_product,
                            quantity: cartGamification.getAttribute('data-pfand'),
                            properties: {
                                "_pfand_key": pfandKey,
                                "_gift_pfand": "true"
                            }
                        });
                        items[0]['properties']['_pfand_key'] =  pfandKey;
                    }
                    fetch(`/cart/add.js`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({items: items})
                    }).then((e)=> e.json()).then((cart)=>{
                        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                            bubbles: true,
                            gamification: true
                        }));
                        // update attribte fot the checkout UI
                        updateCartAttribute(cartGamification,cart.items );
                    });
            }
        }else if((cartGamification.getAttribute('data-status') === 'none_granted' || 
             cartGamification.getAttribute('data-status') === 'shipping_granted') && giftInCart) {
                // console.log('TNTE initCartGamification remvoe');
                let giftItemKey =  giftInCart.key ;

                if(giftInCart.properties['pfand-key'] != ''){
                    let pfandItem = document.querySelector(`.CartItemWrapper[pfand-key="${giftInCart.properties['pfand-key']}"]`);
                    if(pfandItem){
                        await fetch(`/cart/change.js`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({                     
                                id: pfandItem.dataset.key,
                                quantity: 0
                            })
                        });
                    }
                }
                
                fetch(`/cart/change.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({                     
                    id: giftItemKey,
                    quantity: 0
                })
            }).finally(()=>{
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true,
                    gamification: true
                  }));
            });
        }
    }

    function renderGamificationSection(callback) {
        const cartGamification = document.querySelector('.CartGamification');
        if (!cartGamification) return;

        console.log('TNTE renderGamificationSection');
        const caseMatch = localStorage.getItem(GAMIFICATION_URL_PARAMS_CASE) || 0;
        // Use Shopify Section API to render the gamification section
        fetch(`${window.Shopify.routes.root}?section_id=${GAMIFICATION_SECTIONS_CASE[caseMatch]}`, {
            method: 'GET',
            headers: {
                'Accept': 'text/html'
            }
        })
        .then(response => response.text())
        .then(html => {
            // Parse the response to extract the gamification content
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newGamificationContent = doc.querySelector('.CartGamification');
            
            if (newGamificationContent) {
                // Replace the existing gamification content
                cartGamification.innerHTML = newGamificationContent.innerHTML;
                
                // Copy over any data attributes that might have been updated
                Array.from(newGamificationContent.attributes).forEach(attr => {
                    if (attr.name.startsWith('data-')) {
                        cartGamification.setAttribute(attr.name, attr.value);
                    }
                });

                //update shipping note 
                const shippingNote = document.querySelector('#drawer_footer .Cart__Taxes');
                if(cartGamification.getAttribute('data-status') === 'shipping_granted' ||
                    cartGamification.getAttribute('data-status') === 'shipping_gift_granted'){
                        if(shippingNote && window.theme.freeShippingTaxLabel != ''){
                            shippingNote.innerHTML = window.theme.freeShippingTaxLabel;
                        }
                }else{
                    if(shippingNote){
                        shippingNote.innerHTML = window.theme.shippingTextDefault;
                    }
                }
                if(callback) callback();
            }
        })
        .catch(error => {
            console.error('Error rendering gamification section:', error);
        });
    }

    function updateCartAttribute(cartGamification,items){
        if(cartGamification && cartGamification.getAttribute('data-context') != ''){
            // const giftItem = items.find(item => item.properties._gift === 'true');
            let context = cartGamification.getAttribute('data-context');
            // console.log('TNTE updateCartAttribute', giftItem, context);
            // if(giftItem){
            //     context = context + '_' + giftItem.key;
            // }
            fetch(`/cart/update.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    //private attributes(__) only readable in checkout, not reachable in cart.js
                    attributes: {__gamification_context: context}
                })
            });
        }
    }

    // the events to handle add/remvoe gift are dependent on the theme events
    const eventsUpdateCart =[
        "DOMContentLoaded",
        "rerender_cart_event"
    ];
    eventsUpdateCart.forEach((e)=>{
        document.addEventListener(e, (event)=>{
            console.log('TNTE initCartGamification fire ', e);
            if(!event.gamification){
                renderGamificationSection(initCartGamification);
            }
        });
    }); 


    // match url params
    function matchUrlParamsCase() {
        const toCheck = window.theme.GamificationUrlParamsContext_1;
        const toCheck2 = window.theme.GamificationUrlParamsContext_2;
        const urlParams = new URLSearchParams(window.location.search);
        const toCheckParams = new URLSearchParams(toCheck);
        let onematched = false;
        let caseMatch = 1;
        
        if(window.theme.GamificationUrlParamsContext_1_Enabled){
            onematched = true;
            for (const [key, value] of toCheckParams.entries()) {
                if (urlParams.get(key) !== value) {
                    onematched = false;
                    break;
                }
            }
        }

        if(!onematched && window.theme.GamificationUrlParamsContext_2_Enabled){
            onematched = true;
            const toCheckParams2 = new URLSearchParams(toCheck2);
            for (const [key, value] of toCheckParams2.entries()) {
                if (urlParams.get(key) !== value) {
                    onematched = false;
                    break;
                }
            }
            if(onematched){
                caseMatch = 2;
            }
        }
        
        return (onematched)? caseMatch : 0;
    }

    document.addEventListener('DOMContentLoaded', ()=>{
        const caseMatch = parseInt(matchUrlParamsCase());
        console.log('TNTE caseMatch', caseMatch);
        if(caseMatch > 0){
            localStorage.setItem(GAMIFICATION_URL_PARAMS_CASE, caseMatch);
        }
    });

})();

